import { useFormUtils } from "@/app/hooks/useFormUtils";
import Styled from "styled-components";
import FormFieldErrors from "../../Reusable/FormFieldErrors";
import { ICheckbox } from "../../interface";

interface CheckboxStylesProps {
  colorHash?: string | undefined;
}

const CheckboxStyles = Styled.div<CheckboxStylesProps>`
  [type='checkbox']:checked {
    background-image: none;
  };
  [type='checkbox']:checked, [type='radio']:checked{
    border-radius: 50%;
    border: 1px solid ${(props) => (props.colorHash && props.colorHash !== "" ? props.colorHash : "#9ca3af")};
    background-color: ${(props) => (props.colorHash && props.colorHash !== "" ? props.colorHash : "#2563eb")};
  };
  [type='checkbox'], [type='radio']{
    border-radius: 50%;
    border: 1px solid ${(props) => (props.colorHash && props.colorHash !== "" ? props.colorHash : "#9ca3af")};
  }
`;

const FormCheckbox: React.FC<ICheckbox> = ({
  errorMessages,
  fieldError,
  register,
  labelTitle,
  onCheckChange,
  defaultChecked,
  circular,
  colorHash,
  description,
}) => {
  const { deduceFormFieldErrors } = useFormUtils();
  const reducedErrorMessages = deduceFormFieldErrors(errorMessages, fieldError);

  return (
    <fieldset>
      <div className="space-y-5 flex flex-col">
        <div className="relative flex items-start">
          <div className="flex h-6 items-center">
            {circular && circular === true ? (
              <CheckboxStyles colorHash={colorHash}>
                <input
                  {...register}
                  onChange={(e) => onCheckChange && onCheckChange(e.target.checked)}
                  type="checkbox"
                  className="w-5 h-5 rounded text-blue-600 cursor-pointer"
                />
              </CheckboxStyles>
            ) : (
              <input
                {...register}
                checked={defaultChecked && defaultChecked}
                onChange={(e) => onCheckChange && onCheckChange(e.target.checked)}
                type="checkbox"
                className="w-5 h-5 rounded border-2 border-[rgba(128,141,160,0.5)] text-blue-600 cursor-pointer"
              />
            )}
          </div>
          <div className="ml-3 text-sm leading-6">
            <label
              htmlFor={register?.name}
              className=" max-xl:text-[10px] font-[Poppins,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,'Helvetica_Neue',Arial] text-[10px] font-normal text-[#202223] text-left"
            >
              {labelTitle ?? ""}
            </label>
            <p className="text-gray-500">{description ?? ""}</p>
          </div>
        </div>
        <FormFieldErrors errors={reducedErrorMessages} />
      </div>
    </fieldset>
  );
};

export default FormCheckbox;
